import { render, staticRenderFns } from "./jobs2.vue?vue&type=template&id=72a41e16&"
import script from "./jobs2.vue?vue&type=script&lang=js&"
export * from "./jobs2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports